import type { Station } from "@/models/station";
import { apiGet, buildQueryString } from "../client";
import type { Datasource } from "../types";

export interface StationSearchParams {
	search?: string;
	limit?: number;
}

export async function searchStations(
	params: StationSearchParams = {},
): Promise<Station[]> {
	const queryString = buildQueryString({
		search: params.search,
		limit: params.limit ?? 10,
	});

	const response = await apiGet<Datasource.Response<Station[]>>(`/stations?${queryString}`);
	return response.data;
}

export async function fetchStations(): Promise<Station[]> {
	const response = await apiGet<Datasource.Response<Station[]>>("/stations");
	return response.data;
}
